import { confirm } from './imperative'

export async function confirmExitLevel(): Promise<boolean> {
  return confirm({
    description:
      'Se você sair, perderá todo o progresso deste nível. Deseja continuar?',
    variant: 'warning',
    confirmLabel: 'Sair',
    cancelLabel: 'Continuar no nível',
    confirmVariant: 'destructive',
    title: 'Sair do nível?'
  })
}
